module.exports = __webpack_public_path__ + "img/08.1d306de6.png";